<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-14 11:15:53
 * @LastEditTime: 2021-04-30 10:11:05
 * @LastEditors: JDY
-->
<template>
  <page-header-wrapper>
    <template slot="extra">
      <router-link v-action:update :to="{ path: '/settings/form' }">
        <a-button type="primary" icon="edit">编辑配置</a-button>
      </router-link>
    </template>
    <div>
      <a-row>
        <a-col>
          <a-card :loading="siteLoading" :bordered="false">
            <a-descriptions bordered>
              <a-descriptions-item label="网站标题" :span="3">
                {{ siteConfig.title }}
              </a-descriptions-item>
              <a-descriptions-item label="关键词" :span="3">
                {{ siteConfig.keywords }}
              </a-descriptions-item>
              <a-descriptions-item label="介绍" :span="3">
                {{ siteConfig.description }}
              </a-descriptions-item>
              <a-descriptions-item label="版权信息" :span="3">
                {{ siteConfig.copyright }}
              </a-descriptions-item>
              <a-descriptions-item label="联系地址" :span="3">
                {{ siteConfig.address }}
              </a-descriptions-item>
              <a-descriptions-item label="联系我们" :span="3">
                {{ siteConfig.email }}
              </a-descriptions-item>
              <a-descriptions-item label="媒体合作" :span="3">
                {{ siteConfig.email_media }}
              </a-descriptions-item>
              <a-descriptions-item label="反馈与建议" :span="3">
                {{ siteConfig.email_support }}
              </a-descriptions-item>
              <a-descriptions-item label="资金捐赠" :span="3">
                {{ siteConfig.email_money }}
              </a-descriptions-item>
              <a-descriptions-item label="项目捐赠" :span="3">
                {{ siteConfig.email_project }}
              </a-descriptions-item>
              <a-descriptions-item label="项目孵化" :span="3">
                {{ siteConfig.email_project_incubation }}
              </a-descriptions-item>
              <a-descriptions-item label="法律顾问" :span="3">
                {{ siteConfig.email_law }}
              </a-descriptions-item>
              <a-descriptions-item label="公众号二维码" :span="3">
                <img :src="globalUrl + siteConfig.wechat_logo" width="250" />
              </a-descriptions-item>
            </a-descriptions>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </page-header-wrapper>
</template>

<script>
import { requestGet } from '@/api/api'

export default {
    name: 'Workplace',
    components: {},
    data () {
        return {
            siteConfig: {},
            siteLoading: true
        }
    },
    mounted () {
        this.getSite()
    },
    methods: {
        getSite () {
            requestGet('/settings')
                .then(res => {
                    this.siteConfig = res.result
                    this.siteLoading = false
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
}
</script>

<style lang="less" scoped>
@import './index.less';

</style>
